import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "eye", "eyeSlash"]

  connect() {
    this.hide = () => this.setVisible(false)
    document.addEventListener("turbo:before-cache", this.hide)
    this.setVisible(false)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.hide)
    this.setVisible(false)
  }

  toggle() {
    this.setVisible(this.inputTarget.type === "password")
  }

  setVisible(visible) {
    this.inputTarget.type = visible ? "text" : "password"
    this.buttonTarget.setAttribute("aria-pressed", String(visible))
    this.buttonTarget.setAttribute("aria-label", visible ? "Ocultar senha" : "Mostrar senha")
    this.eyeTarget.classList.toggle("hidden", visible)
    this.eyeSlashTarget.classList.toggle("hidden", !visible)
  }
}
